import React from 'react';
import { motion } from 'framer-motion';
import { X, Check } from 'lucide-react';
export function Comparison() {
  const rows = [{
    bad: 'Lees 60 páginas y luego las olvidas',
    good: 'La app te dice EXACTAMENTE qué hacer cada día'
  }, {
    bad: 'Intentas recordar qué suplemento, cuándo y cuánto',
    good: 'Base de datos interactiva con filtros y búsqueda'
  }, {
    bad: 'No sabes si estás progresando',
    good: 'Tracker con gráficos que muestran tu evolución real'
  }, {
    bad: 'Abandonas en la semana 2 por falta de motivación',
    good: 'Rachas, badges y XP que te mantienen enganchado'
  }, {
    bad: 'Buscas en el libro cada vez que tienes una duda',
    good: 'Guías rápidas deslizables con la info en 3 bullets'
  }, {
    bad: "El protocolo de frío dice '2 min' pero no tienes timer",
    good: 'Timer integrado con countdown y celebración'
  }, {
    bad: 'No hay rendición de cuentas',
    good: 'Check-in diario de 30 segundos que crea accountability'
  }];
  return <section className="py-24 px-6 bg-brand-bg-alt" data-id="element-266">
      <div className="max-w-[1000px] mx-auto" data-id="element-267">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-268">
          <h2 className="text-3xl md:text-4xl font-black text-white mb-4" data-id="element-269">
            La Diferencia Entre Leer un eBook y Tener el Sistema BIO-X Completo
          </h2>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-6" data-id="element-270">
          {/* Left Column: Bad */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="bg-brand-red/5 border border-brand-red/20 rounded-[20px] overflow-hidden" data-id="element-271">
            <div className="bg-brand-red/10 p-6 border-b border-brand-red/20" data-id="element-272">
              <h3 className="text-xl font-bold text-white flex items-center gap-2" data-id="element-273">
                <X className="w-6 h-6 text-brand-red" data-id="element-274" /> Solo el Ebook
              </h3>
            </div>
            <div className="p-6 space-y-6" data-id="element-275">
              {rows.map((row, idx) => <div key={idx} className="flex items-start gap-3 opacity-70" data-id="element-276">
                  <X className="w-5 h-5 text-brand-red shrink-0 mt-0.5" data-id="element-277" />
                  <p className="text-white text-sm leading-relaxed" data-id="element-278">
                    {row.bad}
                  </p>
                </div>)}
            </div>
          </motion.div>

          {/* Right Column: Good */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.4
        }} className="bg-brand-cyan/5 border border-brand-cyan rounded-[20px] overflow-hidden shadow-[0_0_30px_rgba(0,212,170,0.1)]" data-id="element-279">
            <div className="bg-brand-cyan/10 p-6 border-b border-brand-cyan/20" data-id="element-280">
              <h3 className="text-xl font-bold text-white flex items-center gap-2" data-id="element-281">
                <Check className="w-6 h-6 text-brand-cyan" data-id="element-282" /> El Ecosistema
                BIO-X 90
              </h3>
            </div>
            <div className="p-6 space-y-6" data-id="element-283">
              {rows.map((row, idx) => <div key={idx} className="flex items-start gap-3" data-id="element-284">
                  <Check className="w-5 h-5 text-brand-cyan shrink-0 mt-0.5" data-id="element-285" />
                  <p className="text-white text-sm font-medium leading-relaxed" data-id="element-286">
                    {row.good}
                  </p>
                </div>)}
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}